export default __webpack_public_path__ + "static/media/bg2.0533a82e.jpg";